module.exports = __webpack_public_path__ + "img/fagao2.49db116d.png";